import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 290px;
  margin: 0 auto;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`

export const Title = styled.h1`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
`

export const Content = styled.div`
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;

  p {
    line-height: 1.5;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 700;
    color: var(--gray-5);
  }
`

export const Footer = styled.footer`
  position: sticky;
  bottom: -25px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  left: 0;
  width: 100%;
  background-color: var(--the-white);
  padding-top: 16px;
  padding-bottom: 16px;

  > * {
    flex: 1;
  }

  > *:only-child {
    flex: none;
    width: 334px;
    max-width: 100%;
    margin: 0 auto;
  }
`

export const Container = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 16px 48px;
`
